var _ellipse, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconContainerMessage = function SvgIconContainerMessage(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 80,
    viewBox: "0 0 96 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4863,
    cy: 39.6006,
    rx: 39.5137,
    ry: 39.5137,
    fill: "#003349",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7598 59.946H70.2345C71.3391 59.946 72.2345 59.0506 72.2345 57.946V37.4836H84.6371C85.7417 37.4836 86.6371 38.3791 86.6371 39.4836V67.3429C86.6371 68.4475 85.7417 69.3429 84.6371 69.3429H80.0917C79.6775 69.3429 79.3417 69.6787 79.3417 70.0929L79.3417 77.97C79.3417 79.2235 77.8954 79.924 76.9118 79.1469L64.7075 69.5044C64.5751 69.3998 64.4113 69.3429 64.2426 69.3429H39.7598C38.6552 69.3429 37.7598 68.4475 37.7598 67.3429V59.946Z",
    fill: "url(#paint0_linear_90_799)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7598 59.946H70.2345C71.3391 59.946 72.2345 59.0506 72.2345 57.946V37.4836H84.6371C85.7417 37.4836 86.6371 38.3791 86.6371 39.4836V67.3429C86.6371 68.4475 85.7417 69.3429 84.6371 69.3429H80.0917C79.6775 69.3429 79.3417 69.6787 79.3417 70.0929L79.3417 77.97C79.3417 79.2235 77.8954 79.924 76.9118 79.1469L64.7075 69.5044C64.5751 69.3998 64.4113 69.3429 64.2426 69.3429H39.7598C38.6552 69.3429 37.7598 68.4475 37.7598 67.3429V59.946Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36426 11.9557C1.25969 11.9557 0.364258 12.8511 0.364258 13.9557V54.5647C0.364258 55.6692 1.25969 56.5647 2.36426 56.5647H9.5801C10.1324 56.5647 10.5801 57.0124 10.5801 57.5647L10.5801 69.8835C10.5801 71.137 12.0264 71.8376 13.01 71.0605L31.0844 56.78C31.2609 56.6405 31.4794 56.5647 31.7043 56.5647H66.8019C67.9064 56.5647 68.8019 55.6692 68.8019 54.5647V13.9557C68.8019 12.8511 67.9064 11.9557 66.8019 11.9557H2.36426Z",
    fill: "url(#paint1_linear_90_799)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36426 11.9557C1.25969 11.9557 0.364258 12.8511 0.364258 13.9557V54.5647C0.364258 55.6692 1.25969 56.5647 2.36426 56.5647H9.5801C10.1324 56.5647 10.5801 57.0124 10.5801 57.5647L10.5801 69.8835C10.5801 71.137 12.0264 71.8376 13.01 71.0605L31.0844 56.78C31.2609 56.6405 31.4794 56.5647 31.7043 56.5647H66.8019C67.9064 56.5647 68.8019 55.6692 68.8019 54.5647V13.9557C68.8019 12.8511 67.9064 11.9557 66.8019 11.9557H2.36426Z",
    fill: "black",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4004,
    y: 24.681,
    width: 48.3656,
    height: 2.65936,
    rx: 1.32968,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4004,
    y: 32.9774,
    width: 48.3656,
    height: 2.65936,
    rx: 1.32968,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4004,
    y: 41.274,
    width: 48.3656,
    height: 2.65936,
    rx: 1.32968,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_799",
    x1: 39.0797,
    y1: 29.7384,
    x2: 84.3811,
    y2: 77.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#07808F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#067989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#056777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02495B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_799",
    x1: 65.2689,
    y1: 5.84068,
    x2: -30.5871,
    y2: 95.4825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#07B0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#067989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#056777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02495B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D40"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconContainerMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-container-message.f5f071c6.svg";
export { ForwardRef as ReactComponent };